// extracted by mini-css-extract-plugin
export default {"buttons-container":"EditSubmittedApplicationPage_buttons-container__yhvSh"};